// One shared entry keeps controls and guarded page interactions available on every route.
import './navigation.js';
import './home.js';
import './booking.js';
